module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('h1', {
    staticClass: "tochead"
  }, [_vm._v("Contents")])]), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Editors"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Editor’s Foreword")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Preface"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_About"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("About Time")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter_1"
    }
  }, [_vm._v("Using the Yearbook of Astronomy as an Observing Guide")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Part_1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Monthly Star Charts")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Northern Hemisphere Star Charts "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Harper")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Southern Hemisphere Star Charts "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Harper")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Planets in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lynne Marie Stockman")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Phases of the Moon in 2019")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eclipses in 2019")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Events in 2019")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Part_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Monthly Sky Notes and Articles 2019")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("January")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter_8#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Closer Look at Lepus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("February")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter_9#sec11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ICON Explores the Ionosphere "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("March")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter_10#sec13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Closer Look at Sextans "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("April")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter_11#sec15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Movable Feasts and Leaping Moons "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Harper")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("May")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter_12#sec17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("When Astronomy Meets the Law "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David Harper")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("June")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter_13#sec19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lunar Occultations and Conjunctions in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("July")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter_14#sec21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Georges Henri Joseph Édouard Lemaître "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David M. Harland")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("August")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter_15#sec24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Light for Gravitational Waves "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("September")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter_16#sec26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Humboldt and the Gegenschein "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("October")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter_17#sec28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Closer Look at Equuleus "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("November")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter_18#sec30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transit of Mercury "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("December")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19#sec32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William Frederick Denning "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Richard Pearson")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19#sec34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Comets in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Norman")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19#sec40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Minor Planets in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Norman")])])]), _vm._v(" "), _c('h4', {
    staticClass: "toc_chapl"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter_19#sec48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meteor Showers in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Norman")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Part_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Article Section")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Astronomy in 2018 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Rod Hine")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Solar System Exploration in 2018 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Peter Rea")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Anniversaries in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Haggath")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cassini-Huygens Mission to the Saturn System "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Carl Murray")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Science Fiction and the Future of Astronomy "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mike Brotherton")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Asaph Hall: Man of Mars "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Norman")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting the Measure of Double Stars "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John McCue")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100 Years of the International Astronomical Union "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Susan Stubbs")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("In Total Support of Einstein: Eddington’s Eclipse, 1919 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Neil Haggath")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The First Micro-Quasar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("David M. Harland")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Father Lucian Kemble and the Kemble Asterisms "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Steve Brown")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mira ‘The Wonderful’ "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roger Pickard")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc_chapt"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Miscellaneous")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter_32#page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Interesting Variable Stars to Observe in 2019 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roger Pickard")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Interesting Double Stars "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Chapter_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Some Interesting Nebulae, Star Clusters and Galaxies "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones")])])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Chapter_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Astronomical Organizations")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Chapter_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Our Contributors")])]), _vm._v(" "), _c('h3', {
    staticClass: "toc_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Glossary "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Brian Jones and David Harper")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a01b224c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0